/**
 * The plan form's answers, saved on this device as they are given, so leaving
 * the page (Exit, a closed tab, a phone call) never loses them. Cleared once
 * the plan is requested; ignored after 14 days.
 */
const KEY = "migrada_plan_draft";
const MAX_AGE_MS = 14 * 24 * 3600 * 1000;

export interface PlanDraft {
  step: number;
  code: string | null;
  start: string | null;
  route: string | null;
  german: string | null;
  english: string | null;
  age: string | null;
  money: string | null;
  email: string;
  minor: boolean;
  parent: string;
  /** Where they are in the move (cases.position). Missing in drafts saved before it was asked. */
  now?: string | null;
}

/*
 * "Continue with Google" leaves the page for Google's sign-in. This mark says
 * the answers on this device should be sent the moment they come back signed
 * in, so they never press anything twice. Taken once; stale after 30 minutes.
 */
const SEND_KEY = "migrada_plan_send_after_signin";
const SEND_MAX_AGE_MS = 30 * 60 * 1000;

export function markSendAfterSignIn(): void {
  try {
    window.localStorage.setItem(SEND_KEY, String(Date.now()));
  } catch {}
}

export function takeSendAfterSignIn(): boolean {
  try {
    const at = Number(window.localStorage.getItem(SEND_KEY));
    window.localStorage.removeItem(SEND_KEY);
    return at > 0 && Date.now() - at < SEND_MAX_AGE_MS;
  } catch {
    return false;
  }
}

export function readPlanDraft(): PlanDraft | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw) as PlanDraft & { at?: number };
    if (!d.at || Date.now() - d.at > MAX_AGE_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return d;
  } catch {
    return null;
  }
}

export function savePlanDraft(d: PlanDraft): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...d, at: Date.now() }));
  } catch {}
}

export function clearPlanDraft(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {}
}
